import { useEffect, useState } from 'react';
import ButtonPrimary from '../../buttons/primary/primary';
import SecondaryButton from '../../buttons/secondary/secondary';
import './style.css';

export interface RubricaTypeOption {
    id: string;
    name: string;
}

export interface CreateRubricaPayload {
    name: string;
    description: string;
    typeId?: string | null;
}

interface CreateRubricaModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (payload: CreateRubricaPayload) => void;
    types: RubricaTypeOption[];
    isLoading?: boolean;
    initialName?: string;
    descriptionText?: string;
}

export default function CreateRubricaModal({
    isOpen,
    onClose,
    onConfirm,
    types,
    isLoading = false,
    initialName = '',
    descriptionText = 'A rubrica será criada quando o projeto for salvo.',
}: CreateRubricaModalProps) {
    const [name, setName] = useState(initialName);
    const [typeId, setTypeId] = useState<string>('');

    useEffect(() => {
        if (isOpen) {
            setName(initialName);
            setTypeId('');
        }
    }, [isOpen, initialName]);

    if (!isOpen) return null;

    const trimmedName = name.trim();
    const canSubmit = trimmedName.length > 0 && !isLoading;

    const submit = () => {
        if (!canSubmit) return;
        onConfirm({
            name: trimmedName,
            description: trimmedName,
            typeId: typeId || null,
        });
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        submit();
    };

    return (
        <div className="rubrica-modal-overlay" style={{ zIndex: 1100 }}>
            <div className="rubrica-modal" style={{ maxWidth: 480 }}>
                <div className="rubrica-modal__header">
                    <h2 className="rubrica-modal__title">Adicionar nova rubrica</h2>
                    <button
                        className="rubrica-modal__close"
                        onClick={onClose}
                        type="button"
                        disabled={isLoading}
                    >
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="rubrica-modal__form">
                    <div className="rubrica-modal__content">
                        <div className="rubrica-modal__info">
                            <p className="rubrica-modal__description">
                                {descriptionText}
                            </p>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                            <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                <span style={{ fontSize: 13, color: '#495057', fontWeight: 500 }}>
                                    Nome da rubrica*
                                </span>
                                <input
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    autoFocus
                                    disabled={isLoading}
                                    style={{
                                        height: 44,
                                        padding: '0 12px',
                                        border: '1px solid #dee2e6',
                                        borderRadius: 6,
                                        fontSize: 14,
                                    }}
                                />
                            </label>

                            <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                <span style={{ fontSize: 13, color: '#495057', fontWeight: 500 }}>
                                    Tipo
                                </span>
                                <select
                                    value={typeId}
                                    onChange={(e) => setTypeId(e.target.value)}
                                    disabled={isLoading}
                                    style={{
                                        height: 44,
                                        padding: '0 12px',
                                        border: '1px solid #dee2e6',
                                        borderRadius: 6,
                                        fontSize: 14,
                                        background: '#fff',
                                    }}
                                >
                                    <option value="">Outros</option>
                                    {types.map((type) => (
                                        <option key={type.id} value={type.id}>
                                            {type.name}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        </div>
                    </div>

                    <div className="rubrica-modal__actions">
                        <SecondaryButton
                            title="Cancelar"
                            onClick={onClose}
                            disabled={isLoading}
                        />
                        <ButtonPrimary
                            title="Adicionar"
                            disabled={!canSubmit}
                            onClick={submit}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
}
